
const LanguageFlag  = ({language = 'fa'})=>{
    if(language === 'en')
    {
        return '🇬🇧';
    }

     if(language === 'ar')
    {
        return '🇦🇪';
    }

    return '🇮🇷';
};

export const  CurrencyFlag  = ({currency = 0})=>{
    console.log('currency:: ',currency)
    if(currency === 0)
    {
        return '🇮🇷';
    }

    if(currency === 1)
    {
        return '🇺🇸';
    }

    if(currency === 2)
    {
        return '🇪🇺';
    }

    if(currency === 3)
    {
        return '🇦🇪';
    }

    return '🇮🇷';
};



export default LanguageFlag;
